export default __webpack_public_path__ + "static/media/vtrx.5d7de41a.png";